import { useFrame } from "@react-three/fiber";
import { Vector3 } from "three";
import { useHoveredRoomNoteStore } from "../../store/hoveredRoomNoteStore";

const projected = new Vector3();

// Lives inside <Canvas>: projects the hovered note icon's world position to page coordinates every frame,
// so the tooltip follows the icon while the camera moves. Mirrors EditHandleTooltipComponent; the tooltip
// itself is rendered by RoomNoteTooltipOverlay, mounted outside the Canvas.
const RoomNoteTooltipComponent = () => {
    const position = useHoveredRoomNoteStore((s) => s.position);

    useFrame(({ camera, gl, size }) => {
        if (!position) return;

        projected.copy(position).project(camera);
        const canvasRect = gl.domElement.getBoundingClientRect();
        const x = canvasRect.left + window.scrollX + (projected.x * 0.5 + 0.5) * size.width;
        const y = canvasRect.top + window.scrollY + (1 - (projected.y * 0.5 + 0.5)) * size.height;

        useHoveredRoomNoteStore.getState().setScreenPosition({ x, y });
    });

    return null;
};

export default RoomNoteTooltipComponent;
